"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderLock: function() {
        return FolderLock;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderLock = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V8C21 7.44772 20.5523 7 20 7H12.6056C12.0133 7 11.4343 6.82469 10.9415 6.49615L8.94915 5.16795C8.78488 5.05844 8.59187 5 8.39445 5H4ZM1 6C1 4.34315 2.34315 3 4 3H8.39445C8.98672 3 9.56575 3.17531 10.0585 3.50385L12.0509 4.83205C12.2151 4.94156 12.4081 5 12.6056 5H20C21.6569 5 23 6.34315 23 8V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM12 11C11.4477 11 11 11.4477 11 12H13C13 11.4477 12.5523 11 12 11ZM12 9C13.6569 9 15 10.3431 15 12V12.2676C15.5978 12.6134 16 13.2597 16 14V15C16 16.1046 15.1046 17 14 17H10C8.89543 17 8 16.1046 8 15V14C8 13.2597 8.4022 12.6134 9 12.2676V12C9 10.3431 10.3431 9 12 9ZM10 14V15H14V14H10Z",
        fill: "currentColor"
    })
}), "FolderLock");
const _default = FolderLock;
